import { useEffect, useState } from "react";
import { getListaById, postLista, patchLista } from "../../services/ListaCabServices";
import { getListaDetById, postListaDet, patchListaDet } from "../../services/ListaDetServices";
import { ListasCabFormContext } from "./ListasCabContext";
import { useNavigate, useParams } from 'react-router-dom';

export const ListasCabFormState = ({ children }) => {
    const [report, setReport] = useState({});
    const [data, setData] = useState({});

    const { id } = useParams();

    const navigate = useNavigate();
    const [detalleListaData, setDetalleListaData] = useState([]);

    useEffect(() => {
        if (id) getListaByIdData(id);
    }, [id]);

    async function getListaByIdData(id) {
        let res = await getListaById(id);
        if (res) setReport(res);
    }

    const postListaData = async (body) => {
        try {
            // Primero grabamos la lista cabecera
             const resCab = await postLista(body);
            // Si hay datos de detalle y la lista cabecera se grabó correctamente
            if (detalleListaData.length > 0 ) {
                const listaCabId =resCab.data.id;

                // Actualizamos el array de detalles añadiendo el ofcab_id a cada elemento
                const detalles = detalleListaData.map(({ id, descripcion, ...item }) => ({
                    ...item,
                    ofcab_id: listaCabId, // Añadir el id de la cabecera
                }));

                // Recorremos cada detalle y lo grabamos uno por uno
                for (const detalleItem of detalles) {
                    await postListaDet(detalleItem);  // Aquí se graba cada item
                }
            }

            // Navegamos a la página de listas después de que todo se haya grabado
            navigate("/listas");

        } catch (error) {
            console.error("Error grabando lista cabecera o detalles:", error);
        }
    };



    const patchListaData = async (id, body) => {
        const resCab = await patchLista(id, body);
        // Si hay datos de detalle y la lista cabecera se grabó correctamente
        if (detalleListaData.length > 0 ) {
            const listaCabId = body.id;

            // Actualizamos el array de detalles añadiendo el ofcab_id a cada elemento
            const detalles = detalleListaData.map(({ id, descripcion, ...item }) => ({
                ...item,
                ofcab_id: listaCabId, // Añadir el id de la cabecera
            }));

            // Recorremos cada detalle y lo grabamos uno por uno
            for (const detalleItem of detalles) {
                await postListaDet(detalleItem);  // Aquí se graba cada item
            }
        }

        navigate("/listas");
    };

    const addItemToArray = (item) => {
        setDetalleListaData((prevData) => [...prevData, item]);
    };

    const getItemFromArrayById = (id) => {
        // Convertimos ambos a string para asegurarnos de que la comparación sea consistente
        const item = detalleListaData.find((item) => String(item.id) === String(id));

        return item || null; // Si no encuentra el elemento, devuelve null
    };


    const updateItemFromArray = (id, updatedFields) => {
        setDetalleListaData((prevState) =>
            prevState.map(item =>
                item.id === id
                    ? { ...item, ...updatedFields }
                    : item
            )
        );
    };

    const removeItemFromArray = (id) => {
        setDetalleListaData((prevState) =>
            prevState.filter(item => item.id !== id)
        );
    };

    const clearArray = () => {
        setDetalleListaData([]); // Establece el estado a un array vacío
    };
    return (
        <ListasCabFormContext.Provider value={{
            report,
            data,
            postListaData,
            patchListaData,
            detalleListaData,
            addItemToArray,
            getItemFromArrayById,
            updateItemFromArray,
            removeItemFromArray,
            clearArray
        }}>
            {children}
        </ListasCabFormContext.Provider>
    );
};
